import { Pipe, PipeTransform } from "@angular/core";
@Pipe({
    name: 'fieldMap'
})

export class FieldMapPipe implements PipeTransform{
    constructor(){}

    transform(value:string,obj:any,keys:string[]) {
      let returnValue;
      if(keys && Array.isArray(keys) && keys.length>0){

        let findObj = JSON.parse(JSON.stringify(obj));
        
        for(let key of keys){
        
          if(key in findObj){
            returnValue = findObj[key];
            findObj = findObj[key];
          }else{
            returnValue = '';
            break;
          }
          
        }
      }

      if(returnValue!='' && returnValue!=undefined && returnValue!=null)  return returnValue;
      return value; // returns default value
    }
}